import type { JSX } from 'react';
import React, { useMemo } from 'react';

import type { WithSlotProps } from '~/components/hocs';
import { withSlot } from '~/components/hocs';
import { SlotsProvider } from '~/components/providers';
import { useTemplate } from '~/hooks';
import { renderChild } from '../utils';

export const NAME = 'RadioInput';

export interface Props extends React.PropsWithChildren, WithSlotProps {
  className?: string;
  id?: string;
  name: string;
  value: string;
  checked?: boolean;
  label?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const RadioInputComponent = (props: Props) => {
  const { id, name, value, checked, label, onChange, onBlur, onFocus } = props;
  const template = useTemplate(NAME);
  const slots = useMemo(
    () => ({
      label: {
        children: label ?? null,
      } satisfies JSX.IntrinsicElements['span'],

      input: {
        id,
        name,
        value,
        checked,
        onChange,
        onBlur,
        onFocus,
      } satisfies JSX.IntrinsicElements['input'],
    }),
    [id, name, value, checked, label, onChange, onBlur, onFocus]
  );

  return <SlotsProvider slots={slots}> {props.children ?? renderChild(template)}</SlotsProvider>;
};

RadioInputComponent.displayName = NAME;

export const RadioInput = withSlot(RadioInputComponent);
